module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/index.js
// module id = 500
// module chunks = 0 15 16 17